import { render, staticRenderFns } from "./inscription-view-toolbar.vue?vue&type=template&id=46c9c4a5&"
import script from "./inscription-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./inscription-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports